"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hasSmoothScroll_1 = __importDefault(require("./hasSmoothScroll"));
var mirrorScrollLeft_1 = __importDefault(require("./mirrorScrollLeft"));
var setElementScroll = function (el, scrollValue, options) {
    if (options === void 0) { options = { instant: false }; }
    var instant = options.instant;
    var denormalizedValue = (0, mirrorScrollLeft_1.default)(el, scrollValue);
    var supportsSmoothScrolling = (0, hasSmoothScroll_1.default)();
    if (!supportsSmoothScrolling) {
        /* eslint-disable-next-line no-param-reassign */
        el.scrollLeft = denormalizedValue;
    }
    else {
        el.scrollTo({
            left: denormalizedValue,
            behavior: !instant ? "smooth" : undefined,
        });
    }
};
exports.default = setElementScroll;
